import React from 'react';

import { Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { BodyStyles } from './Body.styles';
import type { InstagramPostComponentsProps } from './types';

export function Body(props: InstagramPostComponentsProps): React.JSX.Element {
	const { loading, size, previewImageUrl, retryState } = props;

	const bodyStyles = BodyStyles({ size });

	// Disable animation when in failed retry state (static background for better contrast)
	const shouldAnimate = loading && retryState !== 'failed';

	if (loading) {
		if (size === 'xsmall') {
			return (
				<SkeletonContainer loading={shouldAnimate} className="h-full w-full" data-testid="empty-container">
					<Rectangle className="h-full w-full" />
				</SkeletonContainer>
			);
		}
		return (
			<SkeletonContainer loading={shouldAnimate} className={bodyStyles} data-testid="empty-container">
				<Rectangle className="h-full w-full" />
			</SkeletonContainer>
		);
	}

	return <img data-testid="body-image" src={previewImageUrl} className={bodyStyles} alt="" aria-hidden />;
}
